<template>
  <div>
    <page-navigate></page-navigate>
      <section class="bg">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="792"
        height="360"
        viewBox="0 0 792 360"
        fill="none"
      >
        <path
          d="M392.248 0.25C421.214 0.250118 448.17 9.68001 467.881 27.5332C487.588 45.3834 500.07 71.6682 500.07 105.414V254.586C500.07 288.332 487.588 314.617 467.881 332.467C448.17 350.32 421.214 359.75 392.248 359.75C363.282 359.75 336.201 350.319 316.364 332.466C296.532 314.615 283.925 288.331 283.925 254.586V105.414C283.925 71.669 296.532 45.3847 316.364 27.5342C335.891 9.95941 362.437 0.546608 390.892 0.256836L392.248 0.25ZM751.223 12.6807V175.896H791.75V228.601H751.223V350.423H689.182V228.601H543.583V175.741L689.044 12.6807H751.223ZM207.89 12.6807V175.896H248.417V228.601H207.89V350.423H145.848V228.601H0.25V175.741L145.71 12.6807H207.89ZM392.248 57.9268C379.427 57.9268 368.475 62.5506 360.73 70.9355C352.987 79.319 348.469 91.442 348.469 106.409V254.088C348.469 269.055 352.987 281.055 360.731 289.314C368.477 297.575 379.429 302.073 392.248 302.073C405.067 302.073 415.894 297.575 423.515 289.313C431.134 281.053 435.526 269.053 435.526 254.088V106.409C435.526 91.4437 431.133 79.3206 423.516 70.9365C415.896 62.5506 405.069 57.9269 392.248 57.9268ZM145.401 80.9473L70.8516 175.491L70.5322 175.896H145.848V80.3809L145.401 80.9473ZM688.734 80.9473L614.185 175.491L613.865 175.896H689.182V80.3809L688.734 80.9473Z"
          fill="url(#paint0_linear_1_7572)"
          stroke="url(#paint1_linear_1_7572)"
          stroke-width="0.5"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1_7572"
            x1="396"
            y1="0"
            x2="396"
            y2="360"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-opacity="0.05" />
            <stop offset="0.5" stop-opacity="0.02" />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1_7572"
            x1="396"
            y1="0"
            x2="396"
            y2="360"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#E6DDCF" />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
      <h2 class="title-32_medium md-body-16_medium">无法找到此页面</h2>
      <a href="/" class="back-btn primary-default_large content-16_medium md-body-14_medium">
        返回首页
      </a>
    </section>
    <page-footer></page-footer>
  </div>
</template>

<script>
export default {
  mounted(){
		document.documentElement.setAttribute('data-fitter', 'true');
  },
  destroyed() {
		document.documentElement.removeAttribute('data-fitter');
  },
}

</script>

<style scoped>
<style>
      :root {
        background: var(--ebc-neutral-bg_a);
      }
      .bg {
        /* width: 100%; */
        height: calc( 560rem + 80px);
        display: flex;
        flex-direction: column;
        /* justify-content: center; */
        align-items: center;
        position: relative;
      }
      .bg h2{
        color: var(--ebc-text-secondary);
        margin-top: calc(240rem + 80px);
      }
      .bg svg {
        width: 792rem;
        height: auto;
        position: absolute;
        top: calc(100rem + 80px);
        left: 50%;
        transform: translate(-50%, 0);
        z-index: -1;
      }
      .bg-404 {
        width: 397rem;
        height: 149rem;
      }

      .back-btn {
        margin-top: 60rem;
      }
      .back-btn:hover{
        color:#fff;
      }
      @media (max-width: 996px) {
        .bg {
          height: 800rem;
          display: flex;
        }
      .bg h2{
        margin-top: 312rem
      }
        .bg svg {
          width: 606rem;
          height: auto;
          top:206rem;
          left: 50%;
          transform: translate(-50%, 0);
        }
        .bg .back-btn{
          padding-inline: 48rem;
          height:80rem;
        }
      }
</style>